import { Box, styled } from '@mui/material';

import AmplifyLogin from '../LoginAmplify';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';
import React from 'react';
import { loginErrorLink } from 'src/router/routerLink';
import useAuth from '../../../../../hooks/useAuth';
import { parseErrorJson } from '../helper';

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);
function LoginCover() {
  const { method, error } = useAuth();
  function redirectToErrorPage(error) {
    if (!error) return false;

    const customError = parseErrorJson(error.message);
    if (customError && customError.code === 10) {

      return true;
    }

    return false;

  }

  return (
    < >
      <Helmet>
        <title>Login - Cover</title>
      </Helmet>
      {redirectToErrorPage(error) && <Navigate to={loginErrorLink} />}
      <MainContent>
        {method === 'Amplify' && <AmplifyLogin />}
      </MainContent>
    </>
  );
}

export default LoginCover;
